import React from "react";
import { Undo2 } from "lucide-react";

/** Standard back icon for the consumer app — curved undo arrow. */
const AppBackIcon = ({ size = 18, strokeWidth = 2.4, className }) => (
  <Undo2 size={size} strokeWidth={strokeWidth} className={className} aria-hidden />
);

export default AppBackIcon;
